import React from 'react'

const ModalLoadingDevoluciones = () => {
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        
      <div className="relative flex items-center justify-center h-screen">      
                                  <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
                                    <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                                      <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                      <p className="mt-4 text-lg">Cargando</p>
                                    </div>
                                  </div>                              
                                </div>
        
      </div>
    </div>
  </div>
  )
}

export default ModalLoadingDevoluciones